// RM resume at the OTP stage (2026-10-06).
//
// A Zoho / franchisee RM "Resume eKYC" link for a lead still at INITIATED resolves with
// requiresOtp (Flow A on /continue), so the RM enters the customer's OTP. The /continue short
// code is kept here for that one OTP verify: RegistrationApi.otpVerify sends it as
// `handoffCode`, and the BE — only after the OTP itself verifies — labels the session
// RM_ASSISTED, so GET /journey/status.isAssisted is true and the selfie page shows
// "Share via Link" even after a refresh.
//
// sessionStorage = this tab only. The code is a bearer secret: never log it or send it to
// analytics.

const KEY = 'handoffRmCode';

/** handoff_links.purpose values the BE treats as RM-assisted (PostEsignFnoResumeRoute.RmAssistedPurposes). */
export const RM_RESUME_PURPOSES = ['ZOHO_RM_RESUME', 'FRANCHISEE_RESUME'];

export const isRmResumePurpose = (purpose) => RM_RESUME_PURPOSES.includes(purpose);

export const setRmResumeCode = (code) => {
    try { if (code) sessionStorage.setItem(KEY, code); } catch (_) { /* storage blocked */ }
};

export const getRmResumeCode = () => {
    try { return sessionStorage.getItem(KEY) || null; } catch (_) { return null; }
};

export const clearRmResumeCode = () => {
    try { sessionStorage.removeItem(KEY); } catch (_) { /* storage blocked */ }
};
